import styled from "styled-components";

export const ProjectScopeHistory = styled.div`
    padding: 1rem;
    h5 {
        color: ${({ theme }) => theme.purple600};
        margin-bottom: 0.5rem;
    }
    section {
        width: 180px;
        display: grid;
        max-height: 9rem;
        overflow-y: auto;

        a,
        label {
            font-weight: 400;
            font-size: 0.75rem;
            color: ${({ theme }) => theme.gray600};
        }
        a {
            margin-top: 0.5rem;
            text-decoration: underline;
            cursor: pointer;
        }
    }
`;
